export const WPAPIEndpoint: string = window.homeURL + '/wp-json/wp/v2';
export const lmMenus: Record<string, any> = {};